import api from "./axiosConfig";

export interface AutomationRuleDto {
  id: string;
  tenantId: string;
  name: string;
  triggerType: string;
  triggerValue: string;
  actionType: string;
  actionTemplate: string;
  triggerConfig?: Record<string, unknown> | null;
  actionConfig?: Record<string, unknown> | null;
  isActive: boolean;
  createdAt: string;
  lastTriggeredAt?: string | null;
  triggerCount: number;
}

export interface CreateAutomationRuleRequest {
  name: string;
  triggerType: string;
  triggerValue: string;
  actionType: string;
  actionTemplate: string;
  isActive: boolean;
  triggerConfig?: Record<string, unknown>;
  actionConfig?: Record<string, unknown>;
}

export interface UpdateAutomationRuleRequest {
  name?: string;
  triggerType?: string;
  triggerValue?: string;
  actionType?: string;
  actionTemplate?: string;
  isActive?: boolean;
  triggerConfig?: Record<string, unknown> | null;
  actionConfig?: Record<string, unknown> | null;
}

export interface AutomationProcessResultDto {
  rulesEvaluated: number;
  actionsTriggered: number;
}

export const automationsApi = {
  list: () => api.get<AutomationRuleDto[]>("/automations").then((r) => r.data),
  create: (body: CreateAutomationRuleRequest) => api.post<AutomationRuleDto>("/automations", body).then((r) => r.data),
  update: (id: string, body: UpdateAutomationRuleRequest) =>
    api.put<AutomationRuleDto>(`/automations/${id}`, body).then((r) => r.data),
  toggle: (id: string) => api.post<AutomationRuleDto>(`/automations/${id}/toggle`).then((r) => r.data),
  delete: (id: string) => api.delete(`/automations/${id}`),
  process: () => api.post<AutomationProcessResultDto>("/automations/process").then((r) => r.data),
};
